export const PHONE_NUMBER_SAMPLES = [
  "+44 20 7123 4567", // (United Kingdom)
  "+33 1 45 67 89 10", // (France)
  "+81 3 1234 5678", //(Japan)
  "+61 2 9876 5432", //(Australia)
  "+49 30 9876 5432", //(Germany)
];
